import { __assign, __awaiter, __generator } from "tslib";
import { renderIframeAndWaitForPostback, getThreeDsChallengeDisplaySize, } from '../3d-secure';
import { logTaggedMessage } from '../../reporter';
import { threeDsErrors } from '../3ds-utils';
import { removeChallengeIframe } from '../iframe-handler';
var challenge_log = logTaggedMessage({
    module: '3ds',
    sub_module: 'worldpay_challenge',
});
export var performChallenge = function (_a, log) {
    var actionData = _a.data, provider = _a.provider, methodUrl = _a.methodUrl;
    if (log === void 0) { log = challenge_log; }
    return __awaiter(void 0, void 0, void 0, function () {
        var challengeDisplaySize, _b, jwt, orderCode, sessionId, machineCookie, correlationId, dataToServer, success, fail, reqData, logData, resultPromise, e_1, ret;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    challengeDisplaySize = getThreeDsChallengeDisplaySize();
                    _b = actionData, jwt = _b.jwt, orderCode = _b.orderCode, sessionId = _b.sessionId, machineCookie = _b.machineCookie, correlationId = _b.correlationId;
                    dataToServer = {
                        orderCode: orderCode,
                        sessionId: sessionId,
                        machineCookie: machineCookie,
                        correlationId: correlationId,
                    };
                    success = function () { return ({
                        challengeData: {
                            provider: provider,
                            received: {},
                            challengeDisplaySize: challengeDisplaySize,
                            data: dataToServer,
                        },
                    }); };
                    fail = function (error) {
                        return {
                            challengeData: {
                                challengeDisplaySize: challengeDisplaySize,
                                provider: provider,
                                notReceived: { error: error },
                                data: dataToServer,
                            },
                        };
                    };
                    reqData = {
                        JWT: jwt,
                        MD: undefined,
                    };
                    logData = {
                        actionData: actionData,
                        methodUrl: methodUrl,
                        provider: provider,
                        reqData: reqData,
                        dataToServer: dataToServer,
                        machineCookie: machineCookie,
                        correlationId: correlationId,
                    };
                    log('3ds: before render Worldpay challenge', logData);
                    resultPromise = renderIframeAndWaitForPostback('visible', methodUrl, 'POST', reqData);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, resultPromise];
                case 2:
                    _c.sent();
                    log('3ds: received Worldpay challenge success', logData);
                    return [2 /*return*/, success()];
                case 3:
                    e_1 = _c.sent();
                    ret = fail(threeDsErrors.generate3dsError({
                        providerFlow: 'WORLDPAY',
                        step: 'challenge',
                        e: e_1,
                    }));
                    log('3ds: Worldpay Challenge failed', __assign(__assign({}, logData), { e: e_1, ret: ret }));
                    return [2 /*return*/, ret];
                case 4:
                    removeChallengeIframe();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=worldpay-challenge.js.map